import type { NextPageWithLayout } from 'types/global'

import MainLayout from '@layouts/main-layout'
import Login from '@components/auth/login'

const LoginPage: NextPageWithLayout = () => {
  return (
    <>
      <Login />
    </>
  )
}

LoginPage.getLayout = (page) => {
  return <MainLayout>{page}</MainLayout>
}

export default LoginPage
